<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>
          <a class="link-effect" [routerLink]="['/solicitudes-engie']" >Mis Solicitudes</a>
        </li>
        <li>
          <span class="link-effect">Aprobar Solicitud</span>
        </li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Aprobar Solicitud</h3>
    </div>

    <div class="block-content">
      <app-solicitud-master-progress [model]="itemSolicitud" [data]="itemSolicitud" [flujoCompleto]="itemSolicitud.aplicaPersonas"></app-solicitud-master-progress>
      <app-solicitud-master-readonly [model]="itemSolicitud"></app-solicitud-master-readonly>
    </div>

    <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
    </div>

    <div class="block-content">
      <mat-tab-group>
        <mat-tab label="Personal">
          <div class="table-responsive">
            <table
              mat-table
              #tablePersonal
              [dataSource]="itemSolicitud.personas"
              class="table table-striped table-vcenter"
            >
              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    color="primary"
                    aria-label="Editar"
                    (click)="openDialogPersonal(element)"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Trabajador</th>
                <td mat-cell *matCellDef="let element">
                  {{
                    element.nombres +
                      " " +
                      element.apellidoPaterno +
                      " " +
                      element.apellidoMaterno
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dni">
                <th mat-header-cell *matHeaderCellDef>Documento de Identidad</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.nroDocumentoIdentidad }}</td>
              </ng-container>

              <ng-container matColumnDef="cargo">
                <th mat-header-cell *matHeaderCellDef>Cargo</th>
                <td mat-cell *matCellDef="let element">{{ element.cargo }}</td>
              </ng-container>

              <!-- <ng-container matColumnDef="cantidad_documentos">
                <th mat-header-cell *matHeaderCellDef>
                  Cantidad de documentos
                </th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.cantidad_documentos }}
                </td>
              </ng-container> -->

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsPersonal">
              </tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsPersonal">                
              </tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Equipos">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-sm-6 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaEquipos" class="aplica" disabled>
                  <span *ngIf="itemSolicitud.aplicaEquipos">SI REQUIERE EQUIPOS</span><span *ngIf="!itemSolicitud.aplicaEquipos">NO REQUIERE EQUIPOS</span>
                </mat-slide-toggle>
              </div>      
            </div>
          </div>

          <div class="table-responsive" *ngIf="itemSolicitud.aplicaEquipos">
            <table
              mat-table
              #tableEquipos
              [dataSource]="itemSolicitud.equipos"
              class="table table-striped table-vcenter"
            >
              <!-- <ng-container matColumnDef="equipo">
                    <th mat-header-cell *matHeaderCellDef>Equipo</th>
                    <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
                  </ng-container> -->

              <ng-container matColumnDef="marca">
                <th mat-header-cell *matHeaderCellDef>Marca</th>
                <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
              </ng-container>

              <ng-container matColumnDef="modelo">
                <th mat-header-cell *matHeaderCellDef>Modelo</th>
                <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
              </ng-container>

              <ng-container matColumnDef="serie">
                <th mat-header-cell *matHeaderCellDef>Serie</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.serie }}</td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    color="primary"
                    aria-label="Editar"
                    (click)="openDialogEquipo(element)"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsEquipos"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsEquipos"
              ></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Vehiculos">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-sm-6 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaVehiculos" class="aplica" disabled>
                  <span *ngIf="itemSolicitud.aplicaVehiculos">SI REQUIERE VEHÍCULOS</span><span *ngIf="!itemSolicitud.aplicaVehiculos">NO REQUIERE VEHÍCULOS</span>
                </mat-slide-toggle>
              </div>
            </div>                         
          </div>
          <div class="table-responsive" *ngIf="itemSolicitud.aplicaVehiculos">
            <table
              mat-table
              #tableVehiculos
              [dataSource]="itemSolicitud.vehiculos"
              class="table table-striped table-vcenter"
            >
              <ng-container matColumnDef="marca">
                <th mat-header-cell *matHeaderCellDef>Marca</th>
                <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
              </ng-container>

              <ng-container matColumnDef="modelo">
                <th mat-header-cell *matHeaderCellDef>Modelo</th>
                <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
              </ng-container>

              <ng-container matColumnDef="placa">
                <th mat-header-cell *matHeaderCellDef>Placa</th>
                <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
              </ng-container>

              <ng-container matColumnDef="color">
                <th mat-header-cell *matHeaderCellDef>Color</th>
                <td mat-cell *matCellDef="let element">{{ element.color }}</td>
              </ng-container>

              <ng-container matColumnDef="anio">
                <th mat-header-cell *matHeaderCellDef>Año</th>
                <td mat-cell *matCellDef="let element">{{ element.anio }}</td>
              </ng-container>

              <ng-container matColumnDef="chofer">
                <th mat-header-cell *matHeaderCellDef>Chofer</th>
                <td mat-cell *matCellDef="let element">
                  {{
                    element.solicitudChofer.nombres +
                      " " +
                      element.solicitudChofer.apellidoPaterno +
                      " " +
                      element.solicitudChofer.apellidoMaterno
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    color="primary"
                    aria-label="Editar"
                    (click)="openDialogVehiculo(element)"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsVehiculos"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsVehiculos"
              ></tr>
            </table>
          </div>
        </mat-tab>

        <mat-tab label="Documentación Técnica">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-sm-12 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaDocumentacionTecnica" class="aplica" disabled>
                  <span *ngIf="itemSolicitud.aplicaEquipos">SI REQUIERE EQUIPOS</span><span *ngIf="!itemSolicitud.aplicaEquipos">NO REQUIERE EQUIPOS</span>
                </mat-slide-toggle>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-12">
                <div class="table-responsive" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
                  <table mat-table #tableDocumentacionTecnica [dataSource]="itemSolicitud.documentosTecnicos" class="table table-striped table-vcenter">
                    <ng-container matColumnDef="nombre">
                      <th mat-header-cell *matHeaderCellDef>Nombre</th>
                      <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                    </ng-container>
            
                    <ng-container matColumnDef="idRequisito">
                      <th mat-header-cell *matHeaderCellDef>Requisito</th>
                      <td mat-cell *matCellDef="let element" class="centre">{{ element.requisito }}</td>
                    </ng-container>
        
                    <ng-container matColumnDef="fechaVencimiento">
                      <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                      <td mat-cell *matCellDef="let element" class="centre">
                        {{ element.fechaVencimiento | date: "dd/MM/yyyy"}}
                      </td>
                    </ng-container>
        
                    <ng-container matColumnDef="idDocumento">
                      <th mat-header-cell *matHeaderCellDef>Doc.</th>
                      <td mat-cell *matCellDef="let element">
                        <!-- <a>VER</a> -->
                      <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                      </td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDocumentacionTecnica"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsDocumentacionTecnica"></tr>
                  </table>
                </div>
              </div>
            </div>
            
            <div class="form-group sec-lnkcomentarios" *ngIf="itemSolicitud.logsDocumentacionTecnica.length > 0">
              <!-- <label class="col-md-1 control-label">Historial Comentarios:</label> -->
              <div class="col-md-4">
                <app-log-dialog-anchor [logs]="itemSolicitud.logsDocumentacionTecnica"></app-log-dialog-anchor>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>      
    
    <div class="block-content">
        <mat-divider class="engie-divider"></mat-divider>
    </div>

    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-1 control-label">Responsable Inducción:</label>
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="itemSolicitud.idCoordinador" name="idCoordinador">
                <mat-option *ngFor="let item of listaCoordinadores; index as i;" [value]='item.codigoUsuario'>{{ item.nombres + ' ' + item.apellidos}}</mat-option>
              </mat-select>
            </mat-form-field> 
          </div>
        </div>
      </div>

      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-1 control-label">Comentarios:</label>
          <div class="col-md-11">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Comentarios</mat-label>
              <textarea
                matInput
                placeholder="Comentarios"
                [(ngModel)]="itemSolicitud.comentarioPorAprobacionRechazo"
                rows="5"
                name="comentarioPorAprobacionRechazo" [maxlength]="2000"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group sec-lnkcomentarios" *ngIf="itemSolicitud.logs.length > 0">
          <label class="col-md-1 control-label"></label>
          <div class="col-md-4">
            <app-log-dialog-anchor [logs]="itemSolicitud.logs"></app-log-dialog-anchor>
          </div>
        </div>
      </div>
    </div>

    <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
    </div>

    <div class="block-content">
      <div class="form-horizontal pad-25">
        <div class="form-group">
          <div class="col-sm-12 text-right">
            <a class="btn btn-naranja" mat-raised-button (click)="aprobar()">
              <mat-icon>thumb_up_alt</mat-icon> APROBAR
            </a>

            <a class="btn btn-rojo" mat-raised-button (click)="rechazar()">
              <mat-icon>thumb_down_alt</mat-icon> RECHAZAR
            </a>

            <a class="btn btn-naranja2" mat-raised-button
              [routerLink]="['/solicitudes', 'aprobacion']">
              <mat-icon>exit_to_app</mat-icon> SALIR
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{itemSolicitud | json}}</pre> -->
